(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avessia-product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || select.id !== 'av-variant') return;
    const url = new URL(select.dataset.productUrl, window.location.origin);
    url.searchParams.set('variant', select.value);
    window.location.assign(url.href);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.av-pdp') || !form.querySelector('.av-buy') || event.defaultPrevented) return;
    if (typeof window.Shopify?.actions?.updateCart !== 'function') return;
    event.preventDefault();
    if (form.dataset.adding === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.av-cart-status');
    const formData = new FormData(form);
    const root = window.Shopify.routes?.root || '/';
    form.dataset.adding = 'true';
    button.disabled = true;
    status.textContent = 'Adding to bag…';
    try {
      const result = await window.Shopify.actions.updateCart({
        lines: [{ merchandiseId: String(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 }]
      }, { event: { context: 'product' } });
      if (result.userErrors?.length) throw new Error(result.userErrors[0].message);
      status.textContent = result.warnings?.length
        ? result.warnings.map((warning) => warning.message).join(' ') + ' '
        : 'Added to your bag. ';
      const link = document.createElement('a');
      link.href = root + 'cart';
      link.textContent = 'View bag';
      status.append(link);
    } catch (error) {
      status.textContent = error.message || 'Unable to confirm the item was added. Please check your bag before trying again.';
    } finally {
      delete form.dataset.adding;
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
